// extracted by mini-css-extract-plugin
module.exports = {"industries":"industries-module--industries--c9yDg","title":"industries-module--title--P8oIw"};